



















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class StickyListHeader extends Vue {
  /**
   * A prop to disable the sticky behavior
   */
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;
}
